import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Children } from "react";
import PassengersRow from "../../../row/index.js";
import * as S from "./styled.js";
const DesktopPassengersContent = (props)=>{
    const { value , literals , handleOnChange , handleOnSelectChange , children , columns , disableIncrement  } = props;
    const { adultsLabel ='' , passengerDescriptionAdultsLabel ='' , passengerInfoAdultsLabel ='' , childrenLabel ='' , passengerDescriptionChildrenLabel ='' , passengerInfoChildrenLabel ='' , babiesLabel ='' , passengerDescriptionBabiesLabel ='' , passengerInfoBabiesLabel ='' , majorsLabel ='' , passengerDescriptionMajorsLabel ='' , passengerInfoMajorsLabel ='' , youngLabel ='' , passengerDescriptionYoungLabel ='' , passengerInfoYoungLabel ='' , seniorLabel ='' , passengerDescriptionSeniorLabel ='' , passengerInfoSeniorLabel ='' , umnrLabel ='' , passengerDescriptionUmnrLabel ='' , passengerInfoUmnrLabel =''  } = literals ?? {};
    return /*#__PURE__*/ _jsxs("div", {
        "data-testid": "PassengersContent",
        children: [
            /*#__PURE__*/ _jsxs(S.Content, {
                children: [
                    value?.adults && /*#__PURE__*/ _jsx(PassengersRow, {
                        passenger: value.adults,
                        label: adultsLabel,
                        description: passengerDescriptionAdultsLabel,
                        info: passengerInfoAdultsLabel,
                        onChange: handleOnChange('adults'),
                        onSelectChange: handleOnSelectChange('adults'),
                        columns: columns,
                        disableIncrement: disableIncrement
                    }),
                    value?.children && /*#__PURE__*/ _jsx(PassengersRow, {
                        passenger: value.children,
                        label: childrenLabel,
                        description: passengerDescriptionChildrenLabel,
                        info: passengerInfoChildrenLabel,
                        onChange: handleOnChange('children'),
                        onSelectChange: handleOnSelectChange('children'),
                        columns: columns,
                        disableIncrement: disableIncrement
                    }),
                    value?.babies && /*#__PURE__*/ _jsx(PassengersRow, {
                        passenger: value.babies,
                        label: babiesLabel,
                        description: passengerDescriptionBabiesLabel,
                        info: passengerInfoBabiesLabel,
                        onChange: handleOnChange('babies'),
                        onSelectChange: handleOnSelectChange('babies'),
                        columns: columns,
                        disableIncrement: disableIncrement
                    }),
                    value?.majors && /*#__PURE__*/ _jsx(PassengersRow, {
                        passenger: value.majors,
                        label: majorsLabel,
                        description: passengerDescriptionMajorsLabel,
                        info: passengerInfoMajorsLabel,
                        onChange: handleOnChange('majors'),
                        onSelectChange: handleOnSelectChange('majors'),
                        columns: columns,
                        disableIncrement: disableIncrement
                    }),
                    value?.young && /*#__PURE__*/ _jsx(PassengersRow, {
                        passenger: value.young,
                        label: youngLabel,
                        description: value.young.description ?? passengerDescriptionYoungLabel ?? '',
                        info: passengerInfoYoungLabel,
                        onChange: handleOnChange('young'),
                        onSelectChange: handleOnSelectChange('young'),
                        columns: columns,
                        disableIncrement: disableIncrement
                    }),
                    value?.senior && /*#__PURE__*/ _jsx(PassengersRow, {
                        passenger: value.senior,
                        label: seniorLabel,
                        description: value.senior.description ?? passengerDescriptionSeniorLabel ?? '',
                        info: passengerInfoSeniorLabel,
                        onChange: handleOnChange('senior'),
                        onSelectChange: handleOnSelectChange('senior'),
                        columns: columns,
                        disableIncrement: disableIncrement
                    }),
                    value?.umnr && /*#__PURE__*/ _jsx(PassengersRow, {
                        passenger: value.umnr,
                        label: umnrLabel,
                        description: value.umnr.description ?? passengerDescriptionUmnrLabel ?? '',
                        info: passengerInfoUmnrLabel,
                        onChange: handleOnChange('umnr'),
                        onSelectChange: handleOnSelectChange('umnr'),
                        columns: columns,
                        disableIncrement: disableIncrement
                    })
                ]
            }),
            value?.extraInfo && /*#__PURE__*/ _jsx(S.ExtraInfo, {
                className: "extra-info",
                children: value.extraInfo
            }),
            children && Children.map(children, (child)=>child && /*#__PURE__*/ _jsx(S.Content, {
                    $fullWidth: true,
                    children: child
                }))
        ]
    });
};
export default DesktopPassengersContent;

//# sourceMappingURL=index.js.map